"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useTestId", {
  enumerable: true,
  get: function () {
    return _useTestId.default;
  }
});
var _useTestId = _interopRequireDefault(require("./useTestId"));
//# sourceMappingURL=index.js.map